var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CloseIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.329.529a.748.748 0 0 0-1.058 0L6 4.8 1.729.529a.748.748 0 0 0-1.066 1.05L4.95 6 .525 10.425a.742.742 0 1 0 1.05 1.05L6 7.05l4.425 4.425a.743.743 0 0 0 1.05-1.05L7.05 6l4.287-4.421a.748.748 0 0 0-.008-1.05Z",
    fill: "#151414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CloseIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgCloseIcon;